export default {
    patentEditor: {
    // DraftingHeader component
        draftingHeader: {
            back: '返回',
            backToProject: '返回首页',
            defaultTitle: '无标题文档',
            editTitle: '点击编辑标题',
            clickToEditName: '点击编辑',
            screen: {
                single: '单屏',
                split: '分屏',
            },
            aiHiro: 'Hiro',
            save: '保存',
            saveOptions: '保存选项',
            saveToFolder: '保存到文件夹',
            saveSuccess: '保存成功',
            saveFailed: '保存失败',
            export: '导出',
            share: '分享',
            sharePermissionDenied: '只有项目创建者可以分享',
            updateTitleSuccess: '标题更新成功',
            updateTitleFailed: '更新标题失败',
            importing: '正在导入文档...',
            importSuccess: '导入成功',
            importFailed: '导入失败',
        },
        // AddSourceDialog specific i18n
        addSource: {
            title: '添加来源',
            createDocument: '创建文档',
            selectDocumentType: '选择文档类型并创建',
        },
        // Blank document feature (patent-editor specific)
        blank: {
            tab: '空白文档',
            placeholder: '创建空白文档',
            title: '空白文档',
            description: '创建一个空白文档，从头开始撰写',
            action: '创建空白文档',
        },
        // SourceTabs component
        sourceTabs: {
            closeOthers: '关闭其他',
            closeAll: '关闭所有',
            files: '文件',
            originalText: '原文',
        },
    },
};
